import { IApplicationState } from '../../types/redux';
import { EWidgetMode } from '../../types/redux/layout';
import { selectWidgetMode } from './selectWidgetMode';

export const selectIsDepositAmountVisible = (state: IApplicationState): boolean => {
  const mode = selectWidgetMode(state);

  return mode === EWidgetMode.Deposit;
};
